// Condition operators shared between the form schema enum (backend) and the logic engine.
// ESM port of cfai-backend/formLogic/operators.js — keep these in sync.

export const OPERATOR_NAMES = [
    "equals",
    "not_equals",
    "contains",
    "not_contains",
    "greater_than",
    "less_than",
    "greater_than_or_equal",
    "less_than_or_equal",
    "is_empty",
    "is_not_empty",
    "is_one_of",
    "is_not_one_of",
    "regex_matches"
]

export function isEmptyValue(val) {
    return val === undefined || val === null || val === "" || (Array.isArray(val) && val.length === 0)
}

// Numeric strings compare numerically; everything else compares as given.
export function toComparable(val) {
    if (typeof val === "number") return val
    if (typeof val === "string" && val.trim() !== "" && !isNaN(Number(val))) return Number(val)
    return val
}

export const OPERATORS = {
    equals: (answer, value) => {
        if (Array.isArray(answer)) return answer.length === 1 && String(answer[0]) === String(value)
        return String(answer ?? "") === String(value)
    },
    not_equals: (answer, value) => !OPERATORS.equals(answer, value),
    contains: (answer, value) => {
        if (Array.isArray(answer)) return answer.map(String).includes(String(value))
        return String(answer ?? "").includes(String(value))
    },
    not_contains: (answer, value) => !OPERATORS.contains(answer, value),
    greater_than: (answer, value) => toComparable(answer) > toComparable(value),
    less_than: (answer, value) => toComparable(answer) < toComparable(value),
    greater_than_or_equal: (answer, value) => toComparable(answer) >= toComparable(value),
    less_than_or_equal: (answer, value) => toComparable(answer) <= toComparable(value),
    is_empty: (answer) => isEmptyValue(answer),
    is_not_empty: (answer) => !isEmptyValue(answer),
    is_one_of: (answer, value) => {
        const list = Array.isArray(value) ? value : [value]
        const listStrings = list.map(String)
        if (Array.isArray(answer)) return answer.some((a) => listStrings.includes(String(a)))
        return listStrings.includes(String(answer))
    },
    is_not_one_of: (answer, value) => !OPERATORS.is_one_of(answer, value),
    // Safe regex: pattern capped at 200 chars to prevent ReDoS.
    regex_matches: (answer, value) => {
        const pattern = String(value ?? "")
        if (pattern.length > 200) return false
        try { return new RegExp(pattern).test(String(answer ?? "")) }
        catch { return false }
    }
}
